import {createSlice} from "@reduxjs/toolkit";

const keyOf = (item) => String(item?.documentId ?? item?.id ?? "");
const upsert = (items, item) => {
    if (!item) return items;
    const key = keyOf(item);
    const index = items.findIndex((current) => keyOf(current) === key);
    if (index < 0) return [...items, item];
    const next = [...items];
    next[index] = {...next[index], ...item};
    return next;
};
const remove = (items, item) => items.filter((current) => keyOf(current) !== keyOf(item));
const roleBelongsToMembership = (role, membership) => {
    const roleMembership = role?.workspace_membership;
    return !roleMembership || keyOf(roleMembership) === keyOf(membership);
};

const slice = createSlice({
    name: "workspaceGraph",
    initialState: {
        workspaceId: null,
        workspaceMembership: null,
        workspaceMemberships: [],
        userRoles: [],
    },
    reducers: {
        resetWorkspaceGraph: (state, action) => ({
            ...slice.getInitialState(),
            workspaceMemberships: action.payload || [],
        }),
        setWorkspaceGraphWorkspaceId: (state, action) => { state.workspaceId = action.payload || null; },
        setWorkspaceGraphMembership: (state, action) => { state.workspaceMembership = action.payload || null; },
        setWorkspaceGraphMemberships: (state, action) => { state.workspaceMemberships = action.payload || []; },
        upsertWorkspaceUserRole: (state, action) => {
            state.userRoles = upsert(state.userRoles, action.payload);
            if (state.workspaceMembership && roleBelongsToMembership(action.payload, state.workspaceMembership)) {
                state.workspaceMembership.user_roles = upsert(state.workspaceMembership.user_roles || [], action.payload);
            }
        },
        removeWorkspaceUserRole: (state, action) => {
            state.userRoles = remove(state.userRoles, action.payload);
            if (state.workspaceMembership && roleBelongsToMembership(action.payload, state.workspaceMembership)) {
                state.workspaceMembership.user_roles = remove(state.workspaceMembership.user_roles || [], action.payload);
            }
        },
    },
});

export const {
    resetWorkspaceGraph,
    removeWorkspaceUserRole,
    setWorkspaceGraphWorkspaceId, setWorkspaceGraphMembership, setWorkspaceGraphMemberships,
    upsertWorkspaceUserRole,
} = slice.actions;

export const workspaceGraphSelectors = {
    workspaceId: (state) => state.workspaceGraph.workspaceId,
    workspaceMembership: (state) => state.workspaceGraph.workspaceMembership,
    workspaceMemberships: (state) => state.workspaceGraph.workspaceMemberships,
    userRoles: (state) => state.workspaceGraph.userRoles,
};
export default slice.reducer;
